
export default {
  getUrlKey(key) {
    return decodeURIComponent((new RegExp('[?|&]' + key + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
  },
  getAppcategory(text) {
    let hash = window.location.hash;
    if (hash != '') {
      let arr = hash.split('&');
      let para = '';
      arr.map((el, index) => {
        if (el.match(text)) {
          para = arr[index].split('=')[1];
        }
      })
      return para;
    }
  },
  getQueryString(name) {
    let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    let r = window.location.search.substring(1).match(reg);
    if (r != null) {
      return decodeURIComponent(r[2]); // 解密
    }
    return null;
  },
  sortObjByKey(obj) {
    let newobj = Object.keys(obj).sort().reduce(function (acc, key) {
      acc[key] = obj[key];
      return acc;
    }, {});
    return newobj;
  },
  async speedTest(domains, timeout = 2000) {
    const test = (url) => {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), timeout);
      return fetch(url, { 
        signal: controller.signal,
        mode: 'no-cors'
      }).finally(() => clearTimeout(timer));
    };

    // 并行发起请求，返回第一个成功的域名
    return Promise.any(
      domains.map(domain => 
        test(`${domain}/?t=${Date.now()}`)
          .then(() => domain)
      )
    ).catch(() => domains[0]); // 全部失败时返回首个域名
  },
  scriptInsert(url, sucess, failed) {
    return new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.src = url;
      script.onload = () => {
        if (sucess) sucess();
        resolve(true);
      };
      script.onerror = (err) => {
        if (failed) failed();
        reject(err);
      };
      document.getElementsByTagName('head')[0].appendChild(script)
    })
  },
  isiOS() {
    return !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
  },
  // 用于处理上下拉动问题，指定区域可以滚动
  touchScroll(id) {
    var el = document.getElementById(id);
    var scrollStartPos = 0;

    el.addEventListener(
      "touchstart",
      function (event) {
        scrollStartPos = this.scrollTop + event.touches[0].pageY;

        event.stopPropagation;
        // event.preventDefault();
      },
      false
    );

    el.addEventListener(
      "touchmove",
      function (event) {
        this.scrollTop = scrollStartPos - event.touches[0].pageY;
        event.stopPropagation;
        // event.preventDefault();
      },
      false
    );
  },
  // 获取设备信息
  getDeviceInfo() {
      const userAgent = navigator.userAgent;
      // 获取设备品牌
      let brand = '未知';
      if (/iPhone/i.test(userAgent)) {
          brand = 'Apple';
      } else if (/Samsung/i.test(userAgent)) {
          brand = 'Samsung';
      } else if (/Huawei/i.test(userAgent)) {
          brand = 'Huawei';
      } else if (/Xiaomi/i.test(userAgent)) {
          brand = 'Xiaomi';
      } else if (/OPPO/i.test(userAgent)) {
          brand = 'OPPO';
      } else if (/Vivo/i.test(userAgent)) {
          brand = 'Vivo';
      } else if (/Google/i.test(userAgent)) {
          brand = 'Google';
      } else if (/Sony/i.test(userAgent)) {
          brand = 'Sony';
      } else if (/LG/i.test(userAgent)) {
          brand = 'LG';
      } else if (/HTC/i.test(userAgent)) {
          brand = 'HTC';
      } else if (/Motorola/i.test(userAgent)) {
          brand = 'Motorola';
      } else if (/Nokia/i.test(userAgent)) {
          brand = 'Nokia';
      } else if (/iPad/i.test(userAgent)) {
          brand = 'Apple iPad';
      } else if (/Android/i.test(userAgent)) {
          // 尝试从用户代理字符串中提取Android设备品牌
          const androidBrandMatch = userAgent.match(/(?:^|\s)([A-Za-z]+)\s*(?:build|android)/i);
          if (androidBrandMatch && androidBrandMatch[1]) {
              brand = androidBrandMatch[1];
          } else {
              brand = 'Android设备';
          }
      }
      
      // 获取操作系统
      let os = '未知';
      if (/Android/i.test(userAgent)) {
          const androidVersionMatch = userAgent.match(/Android\s([0-9.]+)/);
          os = androidVersionMatch ? `Android ${androidVersionMatch[1]}` : 'Android';
      } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
          const iosVersionMatch = userAgent.match(/OS\s([0-9_]+)/);
          os = iosVersionMatch ? `iOS ${iosVersionMatch[1].replace(/_/g, '.')}` : 'iOS';
      } else if (/Windows Phone/i.test(userAgent)) {
          os = 'Windows Phone';
      } else if (/Windows/i.test(userAgent)) {
          os = 'Windows';
      } else if (/Macintosh/i.test(userAgent)) {
          os = 'Mac OS';
      } else if (/Linux/i.test(userAgent)) {
          os = 'Linux';
      }
      
      // 获取浏览器信息
      let browser = '未知';
      if (/Chrome/i.test(userAgent) && !/Edg/i.test(userAgent)) {
          const chromeVersionMatch = userAgent.match(/Chrome\/([0-9.]+)/);
          browser = chromeVersionMatch ? `Chrome ${chromeVersionMatch[1]}` : 'Chrome';
      } else if (/Firefox/i.test(userAgent)) {
          const firefoxVersionMatch = userAgent.match(/Firefox\/([0-9.]+)/);
          browser = firefoxVersionMatch ? `Firefox ${firefoxVersionMatch[1]}` : 'Firefox';
      } else if (/Safari/i.test(userAgent) && !/Chrome/i.test(userAgent)) {
          const safariVersionMatch = userAgent.match(/Version\/([0-9.]+)/);
          browser = safariVersionMatch ? `Safari ${safariVersionMatch[1]}` : 'Safari';
      } else if (/Edg/i.test(userAgent)) {
          const edgVersionMatch = userAgent.match(/Edg\/([0-9.]+)/);
          browser = edgVersionMatch ? `Edge ${edgVersionMatch[1]}` : 'Edge';
      } else if (/Opera|OPR/i.test(userAgent)) {
          const operaVersionMatch = userAgent.match(/(?:Opera|OPR)\/([0-9.]+)/);
          browser = operaVersionMatch ? `Opera ${operaVersionMatch[1]}` : 'Opera';
      }
      
      return { brand, os, browser };
  }
}
